import React from 'react';

interface CheckCircleIconProps {
  className?: string;
  /**
   * Visual variant. `stroked` (default) uses heroicons outline style; `filled`
   * uses the solid heroicons mini variant (20x20 viewBox).
   */
  variant?: 'stroked' | 'filled';
  strokeWidth?: number | string;
}

export function CheckCircleIcon({
  className = 'h-5 w-5',
  variant = 'stroked',
  strokeWidth = 1.5,
}: CheckCircleIconProps): React.ReactElement {
  if (variant === 'filled') {
    return (
      <svg className={className} fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
          clipRule="evenodd"
        />
      </svg>
    );
  }
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
}
